import Reveal from './Reveal';
import { newsItems } from '../content';

const tagColor: Record<string, string> = {
  界面更新: 'bg-emerald-100 text-emerald-700',
  功能新增: 'bg-amber-100 text-amber-700',
  性能优化: 'bg-stone-200 text-stone-600',
  新手引导: 'bg-rose-100 text-rose-600',
};

export default function NewsTimeline() {
  return (
    <section id="news" className="bg-[#FBF9F4] py-16 md:py-24">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-[0.42fr_1fr] lg:gap-16">
        <Reveal>
          <div className="lg:sticky lg:top-28">
            <p className="font-display text-xs tracking-[0.35em] text-rose-500 uppercase">Newswire · 官方快讯</p>
            <h2 className="mt-3 text-2xl font-bold tracking-tight text-stone-900 md:text-4xl">最近在更新什么</h2>
            <p className="mt-4 text-sm leading-7 text-stone-500 md:text-[15px]">
              版本与功能的每一步迭代都记录在这里。想知道最新版带来了什么，看这条时间线就够了。
            </p>
            <a
              href="#top"
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-emerald-700 transition-colors hover:text-emerald-800"
            >
              回到顶部查看全部 <i className="ri-arrow-up-line text-base"></i>
            </a>
          </div>
        </Reveal>

        <div className="relative">
          <span className="absolute top-1 bottom-1 left-[5px] w-px bg-black/10"></span>
          <div className="flex flex-col gap-7">
            {newsItems.map((item, i) => (
              <Reveal key={item.date} delay={i * 80}>
                <article className="relative flex gap-5 pl-7">
                  <span className="absolute top-1.5 left-0 h-2.5 w-2.5 rounded-full border-2 border-[#FBF9F4] bg-rose-500 ring-2 ring-rose-500/20"></span>
                  <div className="w-14 shrink-0 pt-0.5">
                    <span className="font-display text-base font-semibold text-stone-800">{item.date}</span>
                  </div>
                  <div className="min-w-0 border-b border-black/5 pb-7">
                    <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs ${tagColor[item.tag] ?? 'bg-stone-200 text-stone-600'}`}>
                      {item.tag}
                    </span>
                    <h3 className="mt-2.5 text-base font-semibold text-stone-900 md:text-lg">{item.title}</h3>
                    <p className="mt-1.5 text-sm leading-6 text-stone-500">{item.desc}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}